// Tabela de Preços - Atualizada em Janeiro 2026
import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Ligeiros", "€ 37,47"),
  createData("Pesados", "€ 56,08"),
  createData("Reboques e Semi Reboques", "€ 37,47"),
  createData("Reinspeções de inspeções periódicas obrigatórias", "€ 9,40"),
  createData("Motociclos, Triciclos e Quadriciclos ", "€ 18,87")
];
const rows2 = [
  createData("Atribuição/Reposição de Matricula ", "€ 93,52"),
  createData("Motociclos, triciclos e quadriciclos       ", "€ 46,76"),
  createData("Reinspeções de atribuição de Matricula ", "€ 46,76"),
  createData("Acidentados", "€ 130,80"),
  createData("Adaptação ao GPL", "€ 130,80"),
  createData("Aplicação de Películas", "€ 130,80"),
  createData("Determinação de CO2", "€ 130,80"),
  createData("Classificação de Portagens ", "€ 130,80"),
  createData("Reposição de Matrículas Canceladas", "€ 130,80"),
  createData("Inspeção para Transporte Coletivo de Crianças (TCC)", "€ 130,80"),
  createData("Transformação Veículos N1 para M1 ", "€ 130,80"),
  createData("Reinspeções extraordinárias e facultativas", "€ 65,40"),
  createData("Emissão de 2ª Via", "€ 3,52"),
  createData("Outras Inspeções Determinadas Pelo Imt.Ip", "€ 43,48")
];

const useStyles = makeStyles({
  table: {
    minWidth: 500
  }
});

export default function CustomizedTables() {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table
        className={classes.table}
        size="small"
        aria-label="customized table"
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>Inspecção Periódica Obrigatória</StyledTableCell>
            <StyledTableCell align="left">Preço</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="left">{row.calories}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <TableHead>
          <TableRow>
            <StyledTableCell>Inspecção Extraordinária</StyledTableCell>
            <StyledTableCell align="left"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows2.map(row => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="left">{row.calories}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
